import React, { useState } from 'react';
import { Check, X, BookOpen, Battery, Heart, ShieldCheck, Gift, ChevronLeft, ChevronRight } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { FAQAccordion } from '../components/FAQAccordion';
import { SocialProofPopup } from '../components/SocialProofPopup';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/w2i9jPsjEJnXZ7A8kGw77T/Mockup_-_MegaPack_(SIN_FONDO).png';
const BONUS_1_IMAGE = 'https://cdn.magicpatterns.com/uploads/nkUtmCgcwdziv3FasHLhCX/Bono_1_-_Mockup_(1).png';
const BONUS_2_IMAGE = 'https://cdn.magicpatterns.com/uploads/oR2pLFjCcaUPrADQtcTZWJ/Bono_2_-_Mockup.png';
const BONUS_3_IMAGE = 'https://cdn.magicpatterns.com/uploads/uEGw1svhs8KWvsJLgGxvBc/Bono_3_-_Mockup.png';
const PREVIEW_PAGES = ['https://cdn.magicpatterns.com/uploads/2ey1c8XF9PjunDaw2Zid47/Hoja_1.jpg', 'https://cdn.magicpatterns.com/uploads/8ckcew7hpukf1wH6vCVJDm/Hoja_2.jpg', 'https://cdn.magicpatterns.com/uploads/8CPAQA1qcgNmeoweQivsTw/Hoja_3.jpg', 'https://cdn.magicpatterns.com/uploads/eiYDNErcp9mhvqzwXtY22W/Hoja_4.jpg', 'https://cdn.magicpatterns.com/uploads/rHbHst7BFC28FMqPZaQ826/Hoja_5.jpg', 'https://cdn.magicpatterns.com/uploads/rmL89maZ7YtY92pY9Cx2at/Hoja_6.jpg'];
const SECTION_LINK = '#compra';
export function SalesPage() {
  const [currentPage, setCurrentPage] = useState(0);
  const nextPage = () => {
    setCurrentPage(prev => (prev + 1) % PREVIEW_PAGES.length);
  };
  const prevPage = () => {
    setCurrentPage(prev => (prev - 1 + PREVIEW_PAGES.length) % PREVIEW_PAGES.length);
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 pb-20" data-id="element-34">
      <CountdownTimer data-id="element-35" />
      <SocialProofPopup data-id="element-36" />

      {/* HERO SECTION */}
      <section className="pt-8 pb-12 px-4 md:pt-12 md:pb-20 bg-gradient-to-b from-white to-gray-50" data-id="element-37">
        <div className="max-w-4xl mx-auto text-center" data-id="element-38">
          {/* Blue pill container for buyer persona text */}
          <div className="inline-flex items-center justify-center bg-blue-100 text-blue-700 px-6 py-2 rounded-full mb-6" data-id="element-39">
            <span className="text-sm md:text-base font-medium uppercase tracking-wide" data-id="element-40">
              🥗 PARA PERSONAS QUE QUIEREN SENTIRSE BIEN SIN VIVIR A DIETA
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl font-black tracking-tight text-gray-900 mb-8 leading-tight" data-id="element-41">
            MegaPack · Nutrición que Sostiene
          </h1>

          <div className="mb-6" data-id="element-42">
            <a href={SECTION_LINK} data-id="element-43">
              <img src={PRODUCT_IMAGE} alt="MegaPack Nutrición que Sostiene" className="w-full max-w-lg mx-auto drop-shadow-2xl hover:scale-105 transition-transform duration-300 cursor-pointer" data-id="element-44" />
            </a>
          </div>

          <p className="text-xl md:text-2xl font-bold text-gray-900 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-45">
            El sistema completo diseñado para sentirte{' '}
            <span className="bg-yellow-300 px-1" data-id="element-46">con energía</span>,{' '}
            <span className="bg-yellow-300 px-1" data-id="element-47">liviandad</span> y{' '}
            <span className="bg-yellow-300 px-1" data-id="element-48">sin dietas extremas</span>
          </p>

          <CTAButton data-id="element-49">👉 SÍ, QUIERO ACCEDER AHORA</CTAButton>
        </div>
      </section>

      {/* PROBLEM SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-50">
        <div className="max-w-3xl mx-auto" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-52">
            Si te alimentás "bien", dejame hacerte una pregunta honesta
          </h2>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-53">
            <p className="font-medium" data-id="element-54">
              ¿Te sentís con hinchazón, cansancio o malestar físico… aunque
              sentís que hacés todo bien?
            </p>
            <p data-id="element-55">
              No porque no te cuides. No porque no tengas fuerza de voluntad.
            </p>
            <p className="text-xl font-bold text-gray-900" data-id="element-56">
              Sino porque comer saludable se volvió agotador.
            </p>
            <p data-id="element-57">
              Pensar qué comer. Evitar lo que "no se puede". Sentir culpa si
              algo se sale del plan. Arrancar con motivación… y abandonar cuando
              la vida pasa.
            </p>
            <p data-id="element-58">Y aun así, tu cuerpo no responde como esperás.</p>
            <p className="text-center font-bold text-2xl mt-8 border-l-4 border-[#22c55e] pl-4 py-2 bg-green-50" data-id="element-59">
              Nutrirse no debería sentirse así.
            </p>
          </div>

          <div className="mt-12" data-id="element-60">
            <CTAButton data-id="element-61">QUIERO TERMINAR CON ESTO AHORA</CTAButton>
          </div>
        </div>
      </section>

      {/* PAIN POINTS SECTION */}
      <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-62">
        <div className="max-w-4xl mx-auto" data-id="element-63">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-yellow-400" data-id="element-64">
            El problema que nadie dice en voz alta
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-65">
            <div className="space-y-4" data-id="element-66">
              <p className="text-xl font-medium mb-6" data-id="element-67">
                Si esto te pasa, probablemente te resulte familiar:
              </p>
              <ul className="space-y-4" data-id="element-68">
                {['Probás dietas que no se sostienen', 'Comés "sano", pero seguís con hinchazón', 'Tenés días de energía y otros de agotamiento total', 'Te sentís con pesadez sin entender por qué', 'Vivís entre el control y la culpa'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-69">
                    <X className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-70" />
                    <span className="text-lg" data-id="element-71">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-gray-800 p-8 rounded-xl border border-gray-700" data-id="element-72">
              <p className="text-lg mb-6" data-id="element-73">
                Lo peor es esa sensación constante de:
              </p>
              <p className="text-2xl font-bold italic text-gray-300 mb-8" data-id="element-74">
                "Estoy haciendo todo lo posible… pero mi cuerpo no acompaña."
              </p>

              <div className="space-y-2 font-bold text-red-400 text-xl" data-id="element-75">
                <p data-id="element-76">❌ No es falta de voluntad</p>
                <p data-id="element-77">❌ No es que "fallás"</p>
              </div>

              <p className="mt-6 text-gray-300" data-id="element-78">
                La mayoría de las personas no falla porque no se esfuerza. Falla
                porque nadie le enseñó a nutrirse de una forma que se pueda
                sostener en la vida real.
              </p>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-79">
            <p className="text-xl mb-8" data-id="element-80">
              Dietas rígidas. Reglas imposibles. Prohibiciones constantes. Culpa
              después de comer. Y volver a empezar una y otra vez.
            </p>
            <p className="text-2xl font-bold text-[#22c55e]" data-id="element-81">
              👉 Nutrición que Sostiene nace para cortar ese ciclo.
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-82">
        <div className="max-w-5xl mx-auto" data-id="element-83">
          <div className="text-center mb-16" data-id="element-84">
            <span className="bg-green-100 text-green-800 px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wide" data-id="element-85">
              ✅ LA SOLUCIÓN
            </span>
            <h2 className="text-4xl md:text-5xl font-black mt-6 mb-4" data-id="element-86">
              MegaPack · Nutrición que Sostiene
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-87">
              Un sistema completo de nutrición real, organizado y progresivo.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-88">
            <div className="bg-green-50 p-8 rounded-2xl border border-green-100" data-id="element-89">
              <h3 className="text-2xl font-bold mb-6" data-id="element-90">Diseñado para que:</h3>
              <ul className="space-y-4" data-id="element-91">
                {['Desinflames tu cuerpo', 'Mejores tu digestión', 'Recuperes energía diaria', 'Regules el peso sin dietas', 'Reduzcas dolores y malestares', 'Sostengas el bienestar sin culpa ni rigidez'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-92">
                    <Check className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-93" />
                    <span className="text-lg font-medium text-gray-800" data-id="element-94">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col justify-center items-center text-center p-8 bg-gray-50 rounded-2xl border border-gray-100" data-id="element-95">
              <div className="space-y-6 text-xl font-bold text-gray-800" data-id="element-96">
                <div className="flex items-center gap-4" data-id="element-97">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0" data-id="element-98">
                    1
                  </span>
                  <span className="text-left" data-id="element-99">📂 Abrís el material</span>
                </div>
                <div className="flex items-center gap-4" data-id="element-100">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0" data-id="element-101">
                    2
                  </span>
                  <span className="text-left" data-id="element-102">👆 Elegís qué necesitás hoy</span>
                </div>
                <div className="flex items-center gap-4" data-id="element-103">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0" data-id="element-104">
                    3
                  </span>
                  <span className="text-left" data-id="element-105">
                    🥗 Lo aplicás en tu vida real
                  </span>
                </div>
              </div>
              <p className="mt-8 text-lg text-gray-600 italic" data-id="element-106">
                Sin extremos. Sin exigencias. Sin empezar de cero.
              </p>
            </div>
          </div>

          <CTAButton data-id="element-107">QUIERO EMPEZAR AHORA</CTAButton>
        </div>
      </section>

      {/* MODULES SECTION */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-108">
        <div className="max-w-5xl mx-auto" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-110">
            📘 ¿Qué incluye exactamente el MegaPack?
          </h2>
          <p className="text-center text-xl text-gray-600 mb-12" data-id="element-111">
            🔹 6 TOMOS PRINCIPALES: Un recorrido claro, progresivo y sostenible
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-112">
            {[{
            icon: '📕',
            title: 'Tomo 1 – Reset Nutricional',
            desc: 'Reducí inflamación y volvé a sentir liviandad desde el inicio.'
          }, {
            icon: '📘',
            title: 'Tomo 2 – Digestión Liviana',
            desc: 'Decile adiós a la hinchazón, la pesadez y el malestar digestivo.'
          }, {
            icon: '📗',
            title: 'Tomo 3 – Energía Diaria',
            desc: 'Energía estable sin depender del café ni del azúcar.'
          }, {
            icon: '📙',
            title: 'Tomo 4 – Control de Peso sin Dietas',
            desc: 'Regulá tu peso sin prohibiciones ni efecto rebote.'
          }, {
            icon: '📕',
            title: 'Tomo 5 – Nutrición Antiinflamatoria',
            desc: 'Aliviá dolores, rigidez e inflamación persistente.'
          }, {
            icon: '📒',
            title: 'Tomo 6 – Sostener el Bienestar',
            desc: 'Convertí todo en un estilo de vida flexible y duradero.'
          }].map((tomo, i) => <a href={SECTION_LINK} key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-113">
                <div className="text-4xl mb-4" data-id="element-114">{tomo.icon}</div>
                <h3 className="text-xl font-bold mb-2" data-id="element-115">{tomo.title}</h3>
                <p className="text-gray-600" data-id="element-116">{tomo.desc}</p>
              </a>)}
          </div>

          <p className="text-center text-lg font-medium mt-12 text-gray-700" data-id="element-117">
            👉 Todo organizado para que sepas qué hacer y cuándo, sin confusión.
          </p>
        </div>
      </section>

      {/* BEFORE VS AFTER */}
      <section className="py-16 px-4 bg-white" data-id="element-118">
        <div className="max-w-4xl mx-auto" data-id="element-119">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-120">
            Antes vs Después
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-121">
            <div className="bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-122">
              <h3 className="text-xl font-bold text-red-800 mb-6 text-center" data-id="element-123">
                Antes de Nutrición que Sostiene
              </h3>
              <ul className="space-y-4" data-id="element-124">
                {['Hinchazón frecuente', 'Cansancio constante', 'Culpa al comer', 'Dietas que no duran', 'Relación tensa con la comida'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-125">
                    <X className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-126" />
                    <span className="text-gray-700" data-id="element-127">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-green-50 p-8 rounded-2xl border border-green-100 shadow-lg transform md:-translate-y-4" data-id="element-128">
              <h3 className="text-xl font-bold text-green-800 mb-6 text-center" data-id="element-129">
                Después de Nutrición que Sostiene
              </h3>
              <ul className="space-y-4" data-id="element-130">
                {['Digestión liviana', 'Energía real', 'Claridad al elegir', 'Bienestar sostenido', 'Paz con la comida y el cuerpo'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-131">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-132" />
                    <span className="font-bold text-gray-800" data-id="element-133">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-16 px-4 bg-[#0f172a] text-white" data-id="element-134">
        <div className="max-w-5xl mx-auto" data-id="element-135">
          <div className="text-center mb-12" data-id="element-136">
            <span className="bg-yellow-400 text-black px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wide animate-pulse" data-id="element-137">
              🎁 REGALOS ESPECIALES
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mt-6 mb-4" data-id="element-138">
              BONOS INCLUIDOS HOY
            </h2>
            <p className="text-xl text-yellow-400 font-bold" data-id="element-139">
              ¡GRATIS POR HOY!
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-140">
            {/* Bonus 1 */}
            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-141">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-142">
                <img src={BONUS_1_IMAGE} alt="Bono 1 - Comer sin Culpa" className="w-full h-full object-contain drop-shadow-xl" data-id="element-143" />
              </div>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-144">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-145">
                🎁 Bono #1 – Comer sin Culpa
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-146">
                El complemento emocional del sistema. Para dejar el autosabotaje
                y sostener el proceso desde la calma.
              </p>
            </a>

            {/* Bonus 2 */}
            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-147">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-148">
                <img src={BONUS_2_IMAGE} alt="Bono 2 - 100 Batidos Saludables" className="w-full h-full object-contain drop-shadow-xl" data-id="element-149" />
              </div>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-150">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-151">
                🎁 Bono #2 – 100 Batidos Saludables
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-152">
                Opciones rápidas y reales para días sin tiempo. Energía,
                digestión y saciedad sin picos.
              </p>
            </a>

            {/* Bonus 3 */}
            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-153">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-154">
                <img src={BONUS_3_IMAGE} alt="Bono 3 - Delicias para Antojos" className="w-full h-full object-contain drop-shadow-xl" data-id="element-155" />
              </div>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-156">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-157">
                🎁 Bono #3 – Delicias para Antojos
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-158">
                Recetas dulces para disfrutar sin prohibición. Ideales para
                evitar atracones y abandono.
              </p>
            </a>
          </div>

          <div className="mt-12 text-center space-y-2 text-lg font-medium" data-id="element-159">
            <p data-id="element-160">👉 Los tomos te enseñan qué hacer.</p>
            <p data-id="element-161">👉 Los bonos te ayudan a no abandonar.</p>
            <p className="text-yellow-400 font-bold text-xl mt-4" data-id="element-162">
              Eso es lo que lo vuelve sostenible.
            </p>
          </div>

          <div className="mt-12" data-id="element-163">
            <CTAButton data-id="element-164">QUIERO MIS REGALOS AHORA</CTAButton>
          </div>
        </div>
      </section>

      {/* OFFER STACK SECTION */}
      <section id="compra" className="py-16 px-4 bg-gradient-to-b from-gray-900 to-gray-800" data-id="element-165">
        <div className="max-w-4xl mx-auto" data-id="element-166">
          {/* Big Title */}
          <div className="text-center mb-10" data-id="element-167">
            <span className="bg-red-500 text-white px-4 py-2 rounded-full font-bold text-sm uppercase tracking-wide animate-pulse inline-block mb-4" data-id="element-168">
              ⏰ OFERTA ESPECIAL
            </span>
            <h2 className="text-4xl md:text-6xl font-black text-white uppercase leading-tight" data-id="element-169">
              Oferta por
              <br data-id="element-170" />
              <span className="text-yellow-400" data-id="element-171">Tiempo Limitado</span>
            </h2>
          </div>

          {/* Offer Box */}
          <div className="bg-white rounded-3xl p-6 md:p-12 shadow-2xl" data-id="element-172">
            <h3 className="text-2xl md:text-3xl font-black text-center mb-8 text-gray-900" data-id="element-173">
              📦 Lo que recibís hoy
            </h3>

            <div className="space-y-4 mb-10" data-id="element-174">
              {['6 tomos completos de Nutrición que Sostiene', 'Bono Comer sin Culpa', 'Bono 100 Batidos Saludables', 'Bono Delicias para Antojos', 'Acceso digital inmediato', 'Un solo pago', 'Acceso de por vida'].map((item, i) => <div key={i} className="flex items-center gap-3 text-lg md:text-xl border-b border-gray-200 pb-3 last:border-0" data-id="element-175">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-176" />
                  <span className="font-bold text-gray-800" data-id="element-177">{item}</span>
                </div>)}
            </div>

            <div className="text-center mb-8" data-id="element-178">
              <p className="text-gray-500 text-xl mb-2" data-id="element-179">
                Precio regular:{' '}
                <span className="line-through decoration-red-500 decoration-2" data-id="element-180">
                  49.990ARS
                </span>
              </p>
              <p className="text-5xl md:text-7xl font-black text-[#22c55e]" data-id="element-181">
                🔥 19.990 ARS
              </p>
              <p className="text-gray-600 mt-2 font-medium" data-id="element-182">Solo por hoy</p>
            </div>

            <div className="flex flex-col items-center justify-center w-full" data-id="element-183">
              <a href="https://checkout.tumundoglobal.online/cart/45134986313919:1" className="relative group flex items-center justify-center gap-2 w-full md:max-w-2xl px-6 py-5 md:py-6 bg-[#22c55e] hover:bg-[#16a34a] text-white text-center rounded-xl shadow-xl hover:shadow-2xl transform transition-all duration-200 hover:-translate-y-1 border-b-4 border-[#15803d] active:border-b-0 active:translate-y-1 text-xl md:text-2xl font-bold uppercase tracking-wide" data-id="element-184">
                👉 OBTENER MI MEGAPACK HOY
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 md:w-7 md:h-7" data-id="element-185">
                  <path d="M5 12h14" data-id="element-186" />
                  <path d="m12 5 7 7-7 7" data-id="element-187" />
                </svg>
              </a>
            </div>
          </div>

          {/* GUARANTEE - Outside the offer box */}
          <div className="mt-10 flex flex-col md:flex-row items-center gap-6 bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20" data-id="element-188">
            <ShieldCheck className="w-16 h-16 text-yellow-400 flex-shrink-0" data-id="element-189" />
            <div className="text-center md:text-left" data-id="element-190">
              <h3 className="text-xl font-bold mb-2 text-white" data-id="element-191">
                Garantía de 7 días sin riesgo
              </h3>
              <p className="text-gray-300" data-id="element-192">
                Probalo durante 7 días. Si no es para vos, te devolvemos el 100%
                del dinero. Sin preguntas. Sin complicaciones.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PREVIEW PAGES CAROUSEL */}
      <section className="py-16 px-4 bg-white" data-id="element-193">
        <div className="max-w-4xl mx-auto" data-id="element-194">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-195">
            📖 Revisá algunas hojas
          </h2>
          <p className="text-center text-gray-600 mb-10" data-id="element-196">
            Mirá una muestra del contenido que vas a recibir
          </p>

          {/* Carousel */}
          <div className="relative" data-id="element-197">
            {/* Image Container */}
            <div className="relative overflow-hidden rounded-2xl shadow-2xl bg-gray-100" data-id="element-198">
              <img src={PREVIEW_PAGES[currentPage]} alt={`Hoja ${currentPage + 1} del MegaPack`} className="w-full h-auto" data-id="element-199" />
            </div>

            {/* Navigation Arrows */}
            <button onClick={prevPage} className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 bg-white/90 hover:bg-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110" aria-label="Página anterior" data-id="element-200">
              <ChevronLeft className="w-6 h-6 md:w-8 md:h-8 text-gray-800" data-id="element-201" />
            </button>
            <button onClick={nextPage} className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 bg-white/90 hover:bg-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110" aria-label="Página siguiente" data-id="element-202">
              <ChevronRight className="w-6 h-6 md:w-8 md:h-8 text-gray-800" data-id="element-203" />
            </button>

            {/* Dots Indicator */}
            <div className="flex justify-center gap-2 mt-6" data-id="element-204">
              {PREVIEW_PAGES.map((_, index) => <button key={index} onClick={() => setCurrentPage(index)} className={`w-3 h-3 rounded-full transition-all ${index === currentPage ? 'bg-[#22c55e] w-8' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a hoja ${index + 1}`} data-id="element-205" />)}
            </div>
          </div>

          {/* Page Counter */}
          <p className="text-center text-gray-500 mt-4 font-medium" data-id="element-206">
            Hoja {currentPage + 1} de {PREVIEW_PAGES.length}
          </p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-207">
        <div className="max-w-6xl mx-auto" data-id="element-208">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-209">
            Lo que dicen quienes ya lo probaron
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-210">
            <TestimonialCard name="María Laura" age={42} location="Buenos Aires" quote="Después de años probando dietas, por fin encontré algo que puedo sostener. Mi digestión mejoró en la primera semana." data-id="element-211" />
            <TestimonialCard name="Carlos" age={38} location="Córdoba" quote="Pensé que esto era solo para mujeres, pero me equivoqué. Bajé 8 kilos y tengo más energía que nunca." data-id="element-212" />
            <TestimonialCard name="Gabriela" age={48} location="Rosario" quote="Bajé 6 kilos sin sentir que estaba a dieta. Sin culpa, sin restricciones extremas." data-id="element-213" />
          </div>
          <div className="grid md:grid-cols-3 gap-6 mt-6" data-id="element-214">
            <TestimonialCard name="Martín" age={45} location="Mendoza" quote="La hinchazón que tenía hace años desapareció. Ahora como mejor y me siento liviano todo el día." data-id="element-215" />
            <TestimonialCard name="Valeria" age={35} location="La Plata" quote="Este sistema cambió mi relación con la comida. Simple, real y sostenible." data-id="element-216" />
            <TestimonialCard name="Diego" age={41} location="Santa Fe" quote="Mi esposa me convenció de probarlo. Ahora los dos lo seguimos y nos sentimos increíbles." data-id="element-217" />
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-218">
        <div className="max-w-3xl mx-auto" data-id="element-219">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-220">
            Preguntas frecuentes
          </h2>
          <FAQAccordion data-id="element-221" />
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-20 px-4 bg-gray-900 text-white text-center" data-id="element-222">
        <div className="max-w-3xl mx-auto" data-id="element-223">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-224">
            🌿 Nutrirte puede ser más simple
          </h2>
          <p className="text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-225">
            No necesitás más control.
            <br className="hidden md:block" data-id="element-226" />
            <span className="md:hidden" data-id="element-227"> </span>
            No necesitás más fuerza de voluntad.
          </p>
          <p className="text-xl text-gray-300 mb-10 -mt-4 leading-relaxed" data-id="element-228">
            Necesitás un sistema que te sostenga, no que te exija.
          </p>

          <a href={SECTION_LINK} className="inline-flex flex-col items-center justify-center px-12 py-5 md:py-6 bg-[#22c55e] hover:bg-[#16a34a] text-white text-center rounded-xl shadow-xl hover:shadow-2xl transform transition-all duration-200 hover:-translate-y-1 border-b-4 border-[#15803d] active:border-b-0 active:translate-y-1" data-id="element-229">
            <span className="text-lg md:text-xl font-bold uppercase tracking-wide" data-id="element-230">
              Accedé ahora
            </span>
            <span className="text-xl md:text-2xl font-black uppercase tracking-wide" data-id="element-231">
              al MegaPack
            </span>
          </a>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-8 bg-black text-gray-500 text-center text-sm" data-id="element-232">
        <p data-id="element-233">© 2024 Nutrición que Sostiene. Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-234">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}